<template>
  <header class="header" :class="{ 'header--main': isMainPage }">
    <div class="titlebar">
      <h1 class="logo" v-if="isMainPage">
        <NuxtLink to="/" @click="menuState.closeAllMenus()">
          <svg
            aria-label="빌레터 폰지킴"
            xmlns="http://www.w3.org/2000/svg"
            width="168"
            height="34"
            viewBox="0 0 168 34"
            fill="none"
          >
            <path
              d="M31.6736 12.6339V22.161C31.662 23.9165 31.2261 25.6312 30.4065 27.1193C29.3369 29.0665 27.9244 30.1187 26.9886 30.8104C25.2215 32.1241 23.187 33.0192 20.9549 33.4784C20.8794 33.4959 20.7922 33.5017 20.705 33.5017C20.6236 33.5017 20.5422 33.4959 20.4609 33.4784C18.2229 33.0192 16.1943 32.1241 14.4272 30.8104C13.8169 30.357 13.2124 29.8978 12.5904 29.2584C12.3579 29.02 12.2358 28.712 12.2416 28.3806C12.2416 28.0551 12.3753 27.7471 12.6136 27.5145C13.0961 27.0437 13.875 27.0553 14.3517 27.5378C14.8515 28.0493 15.3689 28.4446 15.892 28.834C17.3045 29.8803 18.9263 30.6127 20.705 31.0138C22.4895 30.6127 24.1113 29.8803 25.5179 28.834C26.3317 28.2295 27.442 27.4041 28.2499 25.9393C28.8719 24.8 29.2032 23.4921 29.2149 22.1552V13.6976C27.8314 13.4593 26.4712 13.0989 25.1634 12.6339C23.6172 12.0875 22.1175 11.3783 20.705 10.5297C19.2983 11.3783 17.7986 12.0875 16.2524 12.6339C14.9387 13.0989 13.5786 13.4593 12.2009 13.6976V20.6729C12.2009 21.353 11.6487 21.9052 10.9686 21.9052C10.2885 21.9052 9.73633 21.353 9.73633 20.6729V12.6339C9.73633 12.0178 10.2013 11.4888 10.8175 11.4132C12.3869 11.2156 13.9331 10.8436 15.427 10.3146C17.043 9.73915 18.595 8.97768 20.0365 8.04183C20.4434 7.78026 20.9666 7.78026 21.3735 8.04183C22.8208 8.97768 24.367 9.73915 25.9888 10.3146C27.4768 10.8436 29.0288 11.2156 30.5983 11.4132C31.2144 11.4888 31.6736 12.0178 31.6736 12.6339Z"
              fill="#1E3A5F"
            />
            <path
              d="M21.9373 14.029V14.8137C21.9257 16.5691 21.4897 18.2839 20.6701 19.772C19.6006 21.725 18.1823 22.7713 17.2464 23.463C15.4852 24.7767 13.4565 25.6719 11.2186 26.1311C11.1314 26.1485 11.05 26.1544 10.9687 26.1544C10.8873 26.1544 10.8059 26.1485 10.7245 26.1311C8.48662 25.6719 6.45215 24.7709 4.69089 23.463C3.75504 22.7713 2.33673 21.725 1.27299 19.772C0.453395 18.2839 0.0116255 16.5749 0 14.8253V5.28658C0 4.67043 0.46502 4.14147 1.08117 4.0659C2.65061 3.86827 4.20262 3.49625 5.69068 2.96729C7.30663 2.39764 8.85863 1.63036 10.3002 0.694506C10.7071 0.432932 11.2302 0.432932 11.6371 0.694506C13.0787 1.63036 14.6307 2.39183 16.2524 2.96729C17.7405 3.49625 19.2925 3.86827 20.862 4.0659C21.1875 4.10659 21.4781 4.27516 21.6816 4.53092C21.8792 4.79249 21.9722 5.11801 21.9257 5.44352C21.885 5.76904 21.7222 6.05967 21.4607 6.26312C21.1991 6.46657 20.8794 6.54795 20.5539 6.50726C18.8101 6.28637 17.0837 5.87948 15.427 5.28658C13.875 4.74018 12.3812 4.03102 10.9687 3.18236C9.56197 4.03102 8.06228 4.74018 6.51028 5.28658C5.20241 5.7516 3.84223 6.11199 2.46461 6.35031V14.8137C2.47623 16.1506 2.80756 17.4585 3.42952 18.592C4.23749 20.0626 5.34773 20.888 6.16152 21.4867C7.5682 22.533 9.18414 23.2654 10.9687 23.6665C12.7532 23.2654 14.3749 22.533 15.7816 21.4867C16.5896 20.888 17.6998 20.0626 18.5136 18.592C19.1356 17.4585 19.4669 16.1506 19.4727 14.8079V14.029C19.4727 13.3489 20.0249 12.7967 20.705 12.7967C21.3851 12.7967 21.9373 13.3489 21.9373 14.029Z"
              fill="#3087E5"
            />
            <path
              d="M42.0379 16.4878C41.0788 16.4878 40.6312 16.2785 40.1662 15.7379L39.5384 14.959C39.0908 14.4417 38.9223 14.029 39.0036 13.0699L39.6256 5.95506H42.9621L42.7412 8.48942H47.8623L48.0831 5.95506H51.4197L50.5884 15.4763C50.5303 16.1216 50.1874 16.4878 49.5712 16.4878H42.0437H42.0379ZM43.1132 24.3233L43.0493 25.0499C43.0435 25.1546 43.0551 25.2592 43.1307 25.3057L43.2004 25.4103C43.2469 25.4859 43.3225 25.4859 43.3981 25.4859H57.337L57.0929 28.2528H42.067C41.1892 28.2528 40.9451 28.0726 40.5208 27.5785L40.1662 27.1658C39.7244 26.6252 39.614 26.3636 39.7012 25.4045L39.9395 22.6609C39.986 22.1145 40.4278 21.8355 41.0207 21.8355H53.6401C53.8494 21.8355 53.9598 21.7309 53.9773 21.5507L54.047 20.7776H40.1081L40.3522 17.9816H56.593C57.1859 17.9816 57.5231 18.3188 57.4707 18.9117L57.1859 22.1959C57.0755 23.4398 56.3256 24.3175 55.0875 24.3175H43.1132V24.3233ZM47.4031 13.6918L47.6181 11.2098H42.4971L42.3634 12.7618C42.346 12.942 42.3925 13.0466 42.4564 13.1512L42.811 13.5639C42.904 13.6686 43.0086 13.6918 43.1598 13.6918H47.4031ZM58.6217 5.78068L57.6509 16.854H54.3435L55.3142 5.78068H58.6217Z"
              fill="#12376D"
            />
            <path
              d="M68.4973 15.61C68.3868 16.8772 67.7416 17.4701 66.4744 17.4701H62.5159L62.1555 21.5797C62.1323 21.8413 62.1962 22.0215 62.3357 22.2017L63.01 23.0562C63.2018 23.2364 63.3239 23.3119 63.5564 23.3119H68.5496L68.2996 26.1834H62.4811C61.4231 26.1834 61.0453 26.0555 60.4117 25.3057L59.4061 24.0618C58.8481 23.3642 58.7202 23.0504 58.8248 21.8355L59.3712 15.5752C59.4236 14.9823 59.7607 14.6974 60.3768 14.6974H64.8236C65.1084 14.6974 65.3293 14.5696 65.3526 14.2847L65.7827 9.39621H60.0165L60.2664 6.54796H68.3868C69.0088 6.54796 69.2645 6.85603 69.2064 7.50706L68.4973 15.6042V15.61ZM75.6528 5.93762L73.7404 27.7936H70.584L71.5489 16.7726H69.1192L69.3692 13.9243H71.7989L72.4964 5.93181H75.6528V5.93762ZM77.1641 5.78068H80.396L78.4545 27.9505H75.2226L77.1641 5.78068Z"
              fill="#12376D"
            />
            <path
              d="M84.6395 26.1892C83.6048 26.1892 83.1747 26.0614 82.5702 25.3115L81.4715 23.9688C80.9135 23.2712 80.8089 22.9574 80.9135 21.7425L82.1749 7.33268C82.233 6.68746 82.5411 6.37358 83.1631 6.37358H93.6376L93.3877 9.22182H85.3719L84.9127 14.4475H91.9229L91.6787 17.2667H84.6686L84.3023 21.4809C84.2791 21.7367 84.343 21.9227 84.529 22.1261L85.2498 23.0562C85.4417 23.2364 85.587 23.3119 85.7962 23.3119H93.1668L92.9168 26.1834H84.6395V26.1892ZM100.985 5.78068L99.0435 27.9505H95.736L96.6951 16.9818H93.1261L93.3761 14.1394H96.9451L97.6775 5.78649H100.985V5.78068Z"
              fill="#12376D"
            />
            <path
              d="M110.413 8.88468H107.129L107.373 6.06549H125.323L125.079 8.88468H121.818L121.522 12.2968H124.782L124.538 15.1159H117.191L117.017 17.0807H125.346L125.096 19.9289H105.211L105.461 17.0807H113.686L113.86 15.1159H106.594L106.839 12.2968H110.123L110.419 8.88468H110.413ZM123.788 25.1255L123.539 27.997H108.85C107.838 27.997 107.524 27.7877 107.001 27.2239L106.484 26.6543C105.943 26.0614 105.839 25.7242 105.943 24.5849L106.234 21.2484H109.571L109.315 24.1722C109.297 24.3815 109.315 24.4803 109.454 24.6372L109.71 24.9744C109.832 25.079 109.931 25.1313 110.111 25.1313H123.794L123.788 25.1255ZM113.424 12.2968H118.185L118.481 8.88468H113.721L113.424 12.2968Z"
              fill="#12376D"
            />
            <path
              d="M135.437 9.29739L135.018 14.1103C134.925 15.1973 135.065 16.232 135.489 17.0342C136.739 19.3128 138.169 21.5855 139.75 23.8874L137.297 25.9335C135.826 23.8118 134.362 21.6379 133.135 19.4406C133.071 19.2837 132.967 19.0279 132.955 18.8187C132.879 19.0802 132.757 19.2837 132.641 19.4406C131.019 21.7192 129.275 23.9397 127.375 26.1137L125.143 24.1199C127.072 21.8704 128.932 19.5162 130.734 16.9818C131.24 16.232 131.589 15.1683 131.688 14.0871L132.106 9.3032H127.038L127.293 6.40845H140.61L140.355 9.3032H135.443L135.437 9.29739ZM146.818 5.78068L144.877 27.9505H141.569L143.511 5.78068H146.818Z"
              fill="#12376D"
            />
            <path
              d="M147.841 16.5401C151.242 15.1973 153.34 14.2905 154.782 13.4593C155.439 13.0699 155.904 12.7618 156.212 12.477C155.45 12.9187 154.311 13.2036 153.276 13.2036H148.44L148.667 10.6169H155.444C156.223 10.6169 156.665 10.5413 156.991 10.3844L157.136 8.70449H149.172L149.405 6.0655H159.804C160.426 6.0655 160.705 6.40264 160.647 7.04786L160.35 10.4134C160.147 12.7153 159.513 14.0348 156.502 15.6624C154.631 16.6738 152.236 17.7084 148.841 18.9756L147.841 16.5459V16.5401ZM165.623 19.0512C166.372 19.0512 166.797 19.5162 166.733 20.266L166.146 26.9914C166.076 27.7703 165.57 28.2353 164.82 28.2353H150.44C149.667 28.2353 149.242 27.7703 149.306 26.9914L149.893 20.266C149.957 19.5162 150.463 19.0512 151.242 19.0512H165.623ZM163.053 25.358L163.356 21.8936H153.009L152.707 25.358H163.053ZM168 5.78068L166.948 17.784H163.64L164.692 5.78068H168Z"
              fill="#12376D"
            />
          </svg>
        </NuxtLink>
      </h1>
      <div class="auth-buttons" v-if="isMainPage">
        <button v-if="!authState.isAuthenticated.value" class="btn-login" @click="handleLogin">로그인</button>
        <button v-else class="btn-logout" @click="handleLogout">로그아웃</button>
      </div>

      <button v-if="!isMainPage" class="btn-back" @click="handleBackButton">
        <svg
          aria-label="뒤로가기"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M15.1387 18.2948L8.86068 11.9705L15.1387 5.64618"
            stroke="#212431"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <h1 v-if="!isMainPage" class="title" @click="goMain()">{{ pageTitle }}</h1>
    </div>

    <div id="allmenu" class="container" :class="{ show: menuState.isAllMenuOpen.value }">
      <h1 class="logo">
        <NuxtLink to="/" @click="menuState.closeAllMenus()">
          <svg
            aria-label="빌레터 폰지킴"
            xmlns="http://www.w3.org/2000/svg"
            width="168"
            height="34"
            viewBox="0 0 168 34"
            fill="none"
          >
            <path
              d="M31.6736 12.6339V22.161C31.662 23.9165 31.2261 25.6312 30.4065 27.1193C29.3369 29.0665 27.9244 30.1187 26.9886 30.8104C25.2215 32.1241 23.187 33.0192 20.9549 33.4784C20.8794 33.4959 20.7922 33.5017 20.705 33.5017C20.6236 33.5017 20.5422 33.4959 20.4609 33.4784C18.2229 33.0192 16.1943 32.1241 14.4272 30.8104C13.8169 30.357 13.2124 29.8978 12.5904 29.2584C12.3579 29.02 12.2358 28.712 12.2416 28.3806C12.2416 28.0551 12.3753 27.7471 12.6136 27.5145C13.0961 27.0437 13.875 27.0553 14.3517 27.5378C14.8515 28.0493 15.3689 28.4446 15.892 28.834C17.3045 29.8803 18.9263 30.6127 20.705 31.0138C22.4895 30.6127 24.1113 29.8803 25.5179 28.834C26.3317 28.2295 27.442 27.4041 28.2499 25.9393C28.8719 24.8 29.2032 23.4921 29.2149 22.1552V13.6976C27.8314 13.4593 26.4712 13.0989 25.1634 12.6339C23.6172 12.0875 22.1175 11.3783 20.705 10.5297C19.2983 11.3783 17.7986 12.0875 16.2524 12.6339C14.9387 13.0989 13.5786 13.4593 12.2009 13.6976V20.6729C12.2009 21.353 11.6487 21.9052 10.9686 21.9052C10.2885 21.9052 9.73633 21.353 9.73633 20.6729V12.6339C9.73633 12.0178 10.2013 11.4888 10.8175 11.4132C12.3869 11.2156 13.9331 10.8436 15.427 10.3146C17.043 9.73915 18.595 8.97768 20.0365 8.04183C20.4434 7.78026 20.9666 7.78026 21.3735 8.04183C22.8208 8.97768 24.367 9.73915 25.9888 10.3146C27.4768 10.8436 29.0288 11.2156 30.5983 11.4132C31.2144 11.4888 31.6736 12.0178 31.6736 12.6339Z"
              fill="#1E3A5F"
            />
            <path
              d="M21.9373 14.029V14.8137C21.9257 16.5691 21.4897 18.2839 20.6701 19.772C19.6006 21.725 18.1823 22.7713 17.2464 23.463C15.4852 24.7767 13.4565 25.6719 11.2186 26.1311C11.1314 26.1485 11.05 26.1544 10.9687 26.1544C10.8873 26.1544 10.8059 26.1485 10.7245 26.1311C8.48662 25.6719 6.45215 24.7709 4.69089 23.463C3.75504 22.7713 2.33673 21.725 1.27299 19.772C0.453395 18.2839 0.0116255 16.5749 0 14.8253V5.28658C0 4.67043 0.46502 4.14147 1.08117 4.0659C2.65061 3.86827 4.20262 3.49625 5.69068 2.96729C7.30663 2.39764 8.85863 1.63036 10.3002 0.694506C10.7071 0.432932 11.2302 0.432932 11.6371 0.694506C13.0787 1.63036 14.6307 2.39183 16.2524 2.96729C17.7405 3.49625 19.2925 3.86827 20.862 4.0659C21.1875 4.10659 21.4781 4.27516 21.6816 4.53092C21.8792 4.79249 21.9722 5.11801 21.9257 5.44352C21.885 5.76904 21.7222 6.05967 21.4607 6.26312C21.1991 6.46657 20.8794 6.54795 20.5539 6.50726C18.8101 6.28637 17.0837 5.87948 15.427 5.28658C13.875 4.74018 12.3812 4.03102 10.9687 3.18236C9.56197 4.03102 8.06228 4.74018 6.51028 5.28658C5.20241 5.7516 3.84223 6.11199 2.46461 6.35031V14.8137C2.47623 16.1506 2.80756 17.4585 3.42952 18.592C4.23749 20.0626 5.34773 20.888 6.16152 21.4867C7.5682 22.533 9.18414 23.2654 10.9687 23.6665C12.7532 23.2654 14.3749 22.533 15.7816 21.4867C16.5896 20.888 17.6998 20.0626 18.5136 18.592C19.1356 17.4585 19.4669 16.1506 19.4727 14.8079V14.029C19.4727 13.3489 20.0249 12.7967 20.705 12.7967C21.3851 12.7967 21.9373 13.3489 21.9373 14.029Z"
              fill="#3087E5"
            />
            <path
              d="M42.0379 16.4878C41.0788 16.4878 40.6312 16.2785 40.1662 15.7379L39.5384 14.959C39.0908 14.4417 38.9223 14.029 39.0036 13.0699L39.6256 5.95506H42.9621L42.7412 8.48942H47.8623L48.0831 5.95506H51.4197L50.5884 15.4763C50.5303 16.1216 50.1874 16.4878 49.5712 16.4878H42.0437H42.0379ZM43.1132 24.3233L43.0493 25.0499C43.0435 25.1546 43.0551 25.2592 43.1307 25.3057L43.2004 25.4103C43.2469 25.4859 43.3225 25.4859 43.3981 25.4859H57.337L57.0929 28.2528H42.067C41.1892 28.2528 40.9451 28.0726 40.5208 27.5785L40.1662 27.1658C39.7244 26.6252 39.614 26.3636 39.7012 25.4045L39.9395 22.6609C39.986 22.1145 40.4278 21.8355 41.0207 21.8355H53.6401C53.8494 21.8355 53.9598 21.7309 53.9773 21.5507L54.047 20.7776H40.1081L40.3522 17.9816H56.593C57.1859 17.9816 57.5231 18.3188 57.4707 18.9117L57.1859 22.1959C57.0755 23.4398 56.3256 24.3175 55.0875 24.3175H43.1132V24.3233ZM47.4031 13.6918L47.6181 11.2098H42.4971L42.3634 12.7618C42.346 12.942 42.3925 13.0466 42.4564 13.1512L42.811 13.5639C42.904 13.6686 43.0086 13.6918 43.1598 13.6918H47.4031ZM58.6217 5.78068L57.6509 16.854H54.3435L55.3142 5.78068H58.6217Z"
              fill="#12376D"
            />
            <path
              d="M68.4973 15.61C68.3868 16.8772 67.7416 17.4701 66.4744 17.4701H62.5159L62.1555 21.5797C62.1323 21.8413 62.1962 22.0215 62.3357 22.2017L63.01 23.0562C63.2018 23.2364 63.3239 23.3119 63.5564 23.3119H68.5496L68.2996 26.1834H62.4811C61.4231 26.1834 61.0453 26.0555 60.4117 25.3057L59.4061 24.0618C58.8481 23.3642 58.7202 23.0504 58.8248 21.8355L59.3712 15.5752C59.4236 14.9823 59.7607 14.6974 60.3768 14.6974H64.8236C65.1084 14.6974 65.3293 14.5696 65.3526 14.2847L65.7827 9.39621H60.0165L60.2664 6.54796H68.3868C69.0088 6.54796 69.2645 6.85603 69.2064 7.50706L68.4973 15.6042V15.61ZM75.6528 5.93762L73.7404 27.7936H70.584L71.5489 16.7726H69.1192L69.3692 13.9243H71.7989L72.4964 5.93181H75.6528V5.93762ZM77.1641 5.78068H80.396L78.4545 27.9505H75.2226L77.1641 5.78068Z"
              fill="#12376D"
            />
            <path
              d="M84.6395 26.1892C83.6048 26.1892 83.1747 26.0614 82.5702 25.3115L81.4715 23.9688C80.9135 23.2712 80.8089 22.9574 80.9135 21.7425L82.1749 7.33268C82.233 6.68746 82.5411 6.37358 83.1631 6.37358H93.6376L93.3877 9.22182H85.3719L84.9127 14.4475H91.9229L91.6787 17.2667H84.6686L84.3023 21.4809C84.2791 21.7367 84.343 21.9227 84.529 22.1261L85.2498 23.0562C85.4417 23.2364 85.587 23.3119 85.7962 23.3119H93.1668L92.9168 26.1834H84.6395V26.1892ZM100.985 5.78068L99.0435 27.9505H95.736L96.6951 16.9818H93.1261L93.3761 14.1394H96.9451L97.6775 5.78649H100.985V5.78068Z"
              fill="#12376D"
            />
            <path
              d="M110.413 8.88468H107.129L107.373 6.06549H125.323L125.079 8.88468H121.818L121.522 12.2968H124.782L124.538 15.1159H117.191L117.017 17.0807H125.346L125.096 19.9289H105.211L105.461 17.0807H113.686L113.86 15.1159H106.594L106.839 12.2968H110.123L110.419 8.88468H110.413ZM123.788 25.1255L123.539 27.997H108.85C107.838 27.997 107.524 27.7877 107.001 27.2239L106.484 26.6543C105.943 26.0614 105.839 25.7242 105.943 24.5849L106.234 21.2484H109.571L109.315 24.1722C109.297 24.3815 109.315 24.4803 109.454 24.6372L109.71 24.9744C109.832 25.079 109.931 25.1313 110.111 25.1313H123.794L123.788 25.1255ZM113.424 12.2968H118.185L118.481 8.88468H113.721L113.424 12.2968Z"
              fill="#12376D"
            />
            <path
              d="M135.437 9.29739L135.018 14.1103C134.925 15.1973 135.065 16.232 135.489 17.0342C136.739 19.3128 138.169 21.5855 139.75 23.8874L137.297 25.9335C135.826 23.8118 134.362 21.6379 133.135 19.4406C133.071 19.2837 132.967 19.0279 132.955 18.8187C132.879 19.0802 132.757 19.2837 132.641 19.4406C131.019 21.7192 129.275 23.9397 127.375 26.1137L125.143 24.1199C127.072 21.8704 128.932 19.5162 130.734 16.9818C131.24 16.232 131.589 15.1683 131.688 14.0871L132.106 9.3032H127.038L127.293 6.40845H140.61L140.355 9.3032H135.443L135.437 9.29739ZM146.818 5.78068L144.877 27.9505H141.569L143.511 5.78068H146.818Z"
              fill="#12376D"
            />
            <path
              d="M147.841 16.5401C151.242 15.1973 153.34 14.2905 154.782 13.4593C155.439 13.0699 155.904 12.7618 156.212 12.477C155.45 12.9187 154.311 13.2036 153.276 13.2036H148.44L148.667 10.6169H155.444C156.223 10.6169 156.665 10.5413 156.991 10.3844L157.136 8.70449H149.172L149.405 6.0655H159.804C160.426 6.0655 160.705 6.40264 160.647 7.04786L160.35 10.4134C160.147 12.7153 159.513 14.0348 156.502 15.6624C154.631 16.6738 152.236 17.7084 148.841 18.9756L147.841 16.5459V16.5401ZM165.623 19.0512C166.372 19.0512 166.797 19.5162 166.733 20.266L166.146 26.9914C166.076 27.7703 165.57 28.2353 164.82 28.2353H150.44C149.667 28.2353 149.242 27.7703 149.306 26.9914L149.893 20.266C149.957 19.5162 150.463 19.0512 151.242 19.0512H165.623ZM163.053 25.358L163.356 21.8936H153.009L152.707 25.358H163.053ZM168 5.78068L166.948 17.784H163.64L164.692 5.78068H168Z"
              fill="#12376D"
            />
          </svg>
        </NuxtLink>
      </h1>
      <div class="nav-container">
        <nav class="gnb">
          <!-- 로그인 전 메뉴 -->
          <ul v-if="!authState.isAuthenticated.value">
            <li>
              <!-- <NuxtLink to="/join" @click="menuState.closeAllMenus()">서비스 가입</NuxtLink> -->
              <button type="button" @click="openPopup({ path: config.public.finprotectionCpfepUrl, title: 'join' })">
                서비스 가입
              </button>
              <!-- 외부가입으로 이동 -->
            </li>
            <li>
              <!-- <NuxtLink to="/bye" @click="menuState.closeAllMenus()">서비스 해지</NuxtLink> -->
              <button type="button" @click="openPopup({ path: '/view/bye', title: 'bye' })">서비스 해지</button>
            </li>
            <li>
              <NuxtLink to="/magazine/financial-magazine" @click="menuState.closeAllMenus()">보안 매거진</NuxtLink>
              <!-- 외부가입으로 이동 -->
            </li>
          </ul>
          <!-- 로그인 후 메뉴 -->
          <ul v-else>
            <li>
              <NuxtLink to="/magazine/financial-magazine" @click="menuState.closeAllMenus()">금융 보안 매거진</NuxtLink>
            </li>
            <li
              class="has-submenu"
              @mouseenter="!isMobile && menuState.openSubmenu()"
              @mouseleave="!isMobile && menuState.closeSubmenu()"
              @focusout="handleSubmenuFocusOut"
              ref="submenuContainer"
            >
              <button
                type="button"
                :class="{ active: menuState.showSubmenu.value }"
                @click="isMobile && menuState.toggleSubmenu()"
                @focus="!isMobile && menuState.openSubmenu()"
                @keydown.escape="menuState.closeSubmenu()"
                @keydown.down.prevent="!isMobile && menuState.openSubmenu()"
              >
                MY
              </button>
              <div v-if="menuState.showSubmenu.value" class="sub-container">
                <ul class="sub-nav">
                  <li :class="{ on: route.path === '/mypage/report' }">
                    <NuxtLink to="/mypage/report" @click="menuState.closeAllMenus()">분실신고 이력</NuxtLink>
                  </li>
                  <li :class="{ on: route.path === '/mypage/inquiry' }">
                    <NuxtLink to="/mypage/inquiry" @click="menuState.closeAllMenus()">금융기관 조회내역</NuxtLink>
                  </li>
                  <li :class="{ on: route.path.startsWith('/device/emergency-contact') }">
                    <NuxtLink to="/device/emergency-contact" @click="menuState.closeAllMenus()"
                      >비상 연락처 관리</NuxtLink
                    >
                  </li>
                  <li :class="{ on: route.path === '/mypage/insurance' }">
                    <NuxtLink to="/mypage/insurance" @click="menuState.closeAllMenus()">분실 피해 보험</NuxtLink>
                  </li>
                  <li :class="{ on: route.path === '/mypage/coupons' }">
                    <NuxtLink to="/mypage/coupons" @click="menuState.closeAllMenus()">쿠폰함</NuxtLink>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
        <div class="auth-buttons">
          <button v-if="!authState.isAuthenticated.value" class="btn-login" @click="handleLogin">로그인</button>
          <button v-else class="btn-logout" @click="handleLogout">로그아웃</button>
        </div>
      </div>
      <button class="btn-close" @click="menuState.toggleAllMenu()">
        <svg
          aria-label="닫기"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18.1689 5.83105L5.83105 18.1689"
            stroke="#212431"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.83105 5.83105L18.1689 18.1689"
            stroke="#212431"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- UI 가이드 버튼 - 개발 환경에서만 표시 -->
    <!-- <NuxtLink v-if="!isGuidePage && isDevelopment" to="/guide" class="btn-guide-dev"> UI 가이드 </NuxtLink> -->
  </header>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import { DEFAULT_SERVICE_NAME } from "~/composables/useServiceName";

const route = useRoute();
const router = useRouter();
const authState = useAuthState();
const menuState = useMenuState();
const { api } = useApi();
const { openAlert, openConfirm } = useModal();

const { openPopup } = usePopup();

const config = useRuntimeConfig();

// 반응형 데이터
const isMobile = ref(false);
const submenuContainer = ref(null);

// 상수
const myPageTabs = {
  report: "분실신고 이력",
  inquiry: "금융기관 조회내역",
  notifications: "비상 연락처 알림 발송 내역",
  insurance: "분실 피해 보험 신청",
  coupons: "쿠폰함",
};

const myPagePaths = [
  "/mypage/report",
  "/mypage/inquiry",
  "/device/emergency-contact",
  "/mypage/insurance",
  "/mypage/coupons",
];

// Computed
const isDevelopment = computed(() => {
  return config.public.nodeEnv !== "production";
});

const isMainPage = computed(() => {
  // return route.path === "/";
  return route.meta && (route.meta.isMain || route.meta.isIntro);
});

const isGuidePage = computed(() => {
  return route.path === "/guide";
});

const pageTitle = computed(() => {
  if (isMainPage.value) {
    return DEFAULT_SERVICE_NAME;
  }

  if (route.path === "/mypage" && route.query.tab) {
    const tabId = route.query.tab;
    return myPageTabs[tabId] || "MY";
  }

  if (route.meta?.title) {
    return route.meta.title;
  }

  return DEFAULT_SERVICE_NAME;
});

const isMyPageActive = computed(() => {
  return myPagePaths.some((path) => route.path.startsWith(path));
});

// Methods
const handleLogin = () => {
  console.log("handleLogin");
  menuState.closeAllMenus();
  navigateTo("/login");
};

const handleLogout = () => {
  console.log("handleLogout");
  logout();
};

const logout = async () => {
  const response = await api("/api/user/logout", {});
  console.log("response", response);
  if (response.resCd == "0000") {
    // 로그아웃 처리
    authState.clearAuth();
    navigateTo("/login");
  } else {
    openAlert({ title: "알림", message: response.resMsg });
  }
};

const handleBackButton = () => {
  const onGuest = isGuestPath(route.path);
  const back = window.history.state?.back;
  const prev = typeof back === "string" ? back : back?.fullPath || back?.path || "";
  if (prev && isGuestPath(prev) === onGuest) {
    router.back();
    return;
  }
  router.push(onGuest ? "/guest" : "/main");
};

const handleSubmenuFocusOut = (event) => {
  if (!isMobile.value) {
    if (submenuContainer.value && !submenuContainer.value.contains(event.relatedTarget)) {
      menuState.closeSubmenu();
    }
  }
};

const handleClickOutside = (event) => {
  if (!isMobile.value) {
    if (submenuContainer.value && !submenuContainer.value.contains(event.target)) {
      menuState.closeSubmenu();
    }
  }
};

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

const goMain = () => {
  navigateTo("/");
};

// Lifecycle
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  checkMobile();
  window.addEventListener("resize", checkMobile);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
  window.removeEventListener("resize", checkMobile);
});
</script>

<style scoped>
/* 기존 스타일을 여기에 추가하세요 */
</style>
